module.exports = {
  messages: {
    CN: {
      freeTrail: "免费版本还有**天到期",
      deadline: "[]年[]月[]日到期",
      price: "按年付费享受83折减免",
      LogOut: "退出登录",
      accountFreeDays: "账号[]免费试用还剩**天",
      UpgradeNow: "去升级",
      RedeemCode: "兑换码",
      RedeemCodeDropdownTitle: "所有兑换码",
      salesCodeTxt: "AI销售代表 X 兑换码",
      recruiterCodeTxt: "AI招聘代表 X 兑换码",
      PrimeCode: "Prime Plan 终身激活码",
      LinkAccountBtn: "绑定账号>",
      LinkedinAccount: "领英账号:",
      RedeemActivationCode: "立即兑换",
      Confirm: "确认",
      Cancel: "取消",
      modalTitle: "Redeem activation code",
      modalInput: "请输入兑换码",
      modalInputError: "请输入有效的兑换码",
      noData: "暂无数据",
      helpTitle: "什么是激活码？",
      helpDes:
        "激活码是通过特定渠道获得的代码，可用于激活 StrategyBrain AI。它适用于精简版、专业版和高级版，具体取决于与代码关联的套餐。激活码仅适用于尚未支付订阅费用的用户。如果您已经付款，请联系客服讨论退款。",
      helpTitle1: "激活码可以用几次？",
      helpDes2: "一个激活码仅限使用1次，不可重复使用。",
      helpTitle2: "激活码的使用流程是什么？",
      helpDes3: "1）获得激活码",
      helpDes4: "2）登录账号进入平台",
      helpDes5: "3）点击右上角激活码",
      helpDes6: "4）点击弹窗下方兑换激活码",
      helpDes7: "5）在兑换弹窗中输入或者粘贴激活码",
      helpDes8: "6）点击确认按钮",
      helpDes9: "7）兑换完成后，绑定您的LinkedIn账号即可",
      helpTitle3: "激活码适用范围？",
      helpDes10:
        "不同类型的激活码所适配的套餐版本和AI不同，lite和pro的激活码是区分Sales Rep和Recruiter的，而prime版本的激活码不用区分，两个AI机器人均可以使用。",
      codeSuccess: "激活码兑换成功",
      ConnectionRequestQuota: "好友请求剩余额度",
      ConnectionMadeQuota: "添加好友剩余额度",
      MessageQuota: "消息额度",
      QuotaWarning: "配额警报",
      LinkedinAccout: "LinkedIn 账号",
      Upgradeplan: "升级方案以提升额度",
    },

    US: {
      freeTrail: "** Days Left on Your Free Trial",
      deadline: "Expires on []/[]/[]",
      price: "Save 67% Now",
      LogOut: "Log Out",
      accountFreeDays: "Account [] has ** days left in the free trial",
      UpgradeNow: "Upgrade Now",
      RedeemCode: "Redeem Code",
      RedeemCodeDropdownTitle: "All activation codes",
      salesCodeTxt: "AI Sales Rep X lifetime activation code.",
      recruiterCodeTxt: "AI Recruiter Rep X lifetime activation code.",
      PrimeCode: "Prime plan lifetime activation code.",
      LinkAccountBtn: "Link Account>",
      LinkedinAccount: "Linkedin Account:",
      RedeemActivationCode: "Redeem activation code",
      Confirm: "Confirm",
      Cancel: "Cancel",
      modalTitle: "Redeem activation code",
      modalInput: "Enter activation code to redeem",
      modalInputError: "Please enter a valid activation code.",
      noData: "No date yet",
      helpTitle: "What is an activation code?",
      helpDes:
        "An activation code is a code obtained through specific channels that can be used to activate StrategyBrain AI. It is applicable to the lite, pro, and prime versions, depending on the package associated with the code. Activation codes are exclusively for users who have not yet paid for a subscription. If you have already made a payment, please contact customer support to discuss a refund.",
      helpTitle1: "How many times can an activation code be used?",
      helpDes2:
        "An activation code can only be used once and cannot be reused.",
      helpTitle2: "What is the process for using an activation code?",
      helpDes3: "1.        Obtain the activation code.",
      helpDes4: "2.        Log in to your account and access the platform.",
      helpDes5:
        "3.        Click on “Lifetime Deals Redeem code” in the top-right corner.",
      helpDes6:
        "4.        In the popup, click “Redeem activation code” at the bottom.",
      helpDes7:
        "5.        Enter or paste the activation code in the redemption popup.",
      helpDes8: "6.        Click the “Confirm” button.",
      helpDes9:
        "7.        Once redemption is complete, bind your LinkedIn account to proceed.",
      helpTitle3: "What is the scope of an activation code?",
      helpDes10:
        "The applicable package versions and AI vary based on the type of activation code. Lite and Pro activation codes are specific to either Sales Rep or Recruiter, while Prime activation codes do not require differentiation and can be used for both AI bots.",
      codeSuccess: "The activation code has been successfully redeemed.",
      ConnectionRequestQuota: "Connection Request Quota",
      ConnectionMadeQuota: "Connection Made Quota",
      MessageQuota: "Message Quota",
      QuotaWarning: "Quota Warning",
      LinkedinAccout: "Linkedin Accout",
      Upgradeplan: "Upgrade plan to increase quota",
    },
    AR: {
      freeTrail: "متبقي ** أيام على انتهاء النسخة المجانية",
      deadline: "[]/[]/[]ينتهي في",
      price: "وفر الآن 67%",
      LogOut: "تسجيل الخروج",
      accountFreeDays: "الحساب ** يتبقى له [] يومًا في فترة التجربة المجانية",
      UpgradeNow: "ترقية الآن",
      RedeemCode: "استرد الرمز",
      RedeemCodeDropdownTitle: "جميع رموز التفعيل",
      salesCodeTxt: "رمز التفعيل مدى الحياة لخطة AI Sales Rep X.",
      recruiterCodeTxt: "رمز التفعيل مدى الحياة لخطة AI Recruiter X.",
      PrimeCode: "رمز التفعيل مدى الحياة لخطة Prime.",
      LinkAccountBtn: "ربط الحساب>",
      LinkedinAccount: "حساب لينكد إن:",
      RedeemActivationCode: "سترد رمز التفعيل",
      Confirm: "تأكيد",
      Cancel: "إلغاء",
      modalTitle: "Redeem activation code",
      modalInput: "أدخل رمز التفعيل لاسترداد",
      modalInputError: "الرجاء إدخال رمز تفعيل صالح",
      noData: "لا توجد بيانات حاليًا.",
      helpTitle: "ما هو رمز التفعيل؟",
      helpDes:
        "رمز التفعيل هو رمز يتم الحصول عليه من خلال قنوات محددة ويمكن استخدامه لتفعيل StrategyBrain AI. وهو صالح للإصدارات Lite و Pro و Prime، بناءً على الباقة المرتبطة بالرمز. إن رموز التفعيل مخصصة حصريًا للمستخدمين الذين لم يدفعوا بعد مقابل الاشتراك. إذا كنت قد قمت بالفعل بالدفع، فيرجى التواصل مع خدمة العملاء لمناقشة استرداد المبلغ.",
      helpTitle1: "كم مرة يمكن استخدام رمز التفعيل؟",
      helpDes2:
        "يمكن استخدام رمز التفعيل مرة واحدة فقط ولا يمكن استخدامه مرة أخرى.",
      helpTitle2: "ما هي خطوات استخدام رمز التفعيل؟",
      helpDes3: "1.        الحصول على رمز التفعيل.",
      helpDes4: "2.        تسجيل الدخول إلى الحساب والوصول إلى المنصة.",
      helpDes5:
        "3.        الضغط على “استرداد رمز الصفقات الدائمة” في الزاوية العلوية اليمنى.",
      helpDes6:
        "4.        في النافذة المنبثقة، الضغط على “استرداد رمز التفعيل” أسفل النافذة.",
      helpDes7: "5.        إدخال أو لصق رمز التفعيل في نافذة الاسترداد.",
      helpDes8: "6.        الضغط على زر “تأكيد”.",
      helpDes9:
        "7.        بعد إتمام الاسترداد، قم بربط حساب LinkedIn الخاص بك للمتابعة.",
      helpTitle3: "ما هو نطاق رمز التفعيل؟",
      helpDes10: `يعتمد نطاق رمز التفعيل على نوعه. رموز التفعيل Lite وPro مخصصة إما لـ Sales Rep أو Recruiter، بينما رموز التفعيل Prime لا تتطلب التفريق ويمكن استخدامها لكلا الروبوتين الذكيين.`,
      codeSuccess: "تم استرداد رمز التفعيل بنجاح.",
      ConnectionRequestQuota: "حصة طلبات الاتصال",
      ConnectionMadeQuota: "حصص الاتصالات المُنشأة",
      MessageQuota: "حصة الرسائل",
      QuotaWarning: " إنذار الحصة",
      LinkedinAccout: "حساب لينكد إن ",
      Upgradeplan: `ترقية الباقة لرفع الحد`,
    },
  },
};
